(function () {
  'use strict';

  //#region PRODUCT
  // ─── CONFIGURATION ────────────────────────────────────────────────────────────

  /**
   * Shopify collection IDs (numeric) where these enhancements activate.
   * A product must belong to at least one listed collection.
   * Leave empty to activate on all product pages (not recommended).
   * e.g.: 123456789012,
   */
  const PUBLIC_COLLECTIONS = [
    480388743412,
  ];

  /**
   *   skuOptionName   {string}  Option name in English (or default locale).
   *   skuOptionNameFR {string}  Option name in French — set if translated in your store.
   *   skuMap          {Object}  Option value → SKU (English/default values).
   *   skuMapFR        {Object}  Option value → SKU (French values) — only needed if
   *                             Shopify translates the option values in your store.
   *                             Often not needed if values like 'Black' stay untranslated.
   *
   * Example:
   *   9876543210: {
   *     baseTitleEN:     'Antistatic Flight Suit FR',
   *     baseTitleFR:     'Combinaison de vol antistatique FR',
   *     titleTemplate:   '{sku} - {title} - Public',
   *     skuOptionName:   'Color',
   *     skuOptionNameFR: 'Couleur',
   *     skuMap: {
   *       'Black':     'FLGT01',
   *       'Dark Navy': 'FLGT02',
   *     },
   *     skuMapFR: {        // only add this if Shopify translates these values in French
   *       'Noir':          'FLGT01',
   *       'Bleu marine':   'FLGT02',
   *     },
   *   },
   */
  const VARIANT_SKU_CONFIG = {
    9472048922868: {
        baseTitleEN: 'Antistatic Flight Suit FR',
        baseTitleFR: 'Combinaison de vol antistatique FR',
        titleTemplateEN: '{sku} - {title} - Public',
        titleTemplateFR: '{sku} - {title} - Publique',
        skuOptionName: 'Color',
        skuOptionNameFR: 'Couleur',
        skuMap: {
            'Black':     'FLGT01',
            'Dark Navy': 'FLGT02',
        },
    },
  };

  /**
   * Per-product table-move configuration.
   * Moves a table out of the description tab into a specified tab on page load.
   *
   *   targetTabTitleEN {string}  Exact tab heading in English.
   *   targetTabTitleFR {string}  Exact tab heading in French.
   *
   * Example:
   *   9876543210: {
   *     tableSelector:    '#measurement-table',
   *     targetTabTitleEN: 'Product Specs',
   *     targetTabTitleFR: 'Spécifications',
   *   },
   */
  const TABLE_MOVE_CONFIG = {
    9472048922868: {
        tableSelector:  '[data-move-to-tab]',
        targetTabTitleEN: 'Product Specs',
        targetTabTitleFR: 'Spécifications du produit',
    },
  };

  // ─── SELECTORS ────────────────────────────────────────────────────────────────
  // Adjust if your theme markup ever changes.

  const SEL = {
    section:         '[data-section-type="product"]',
    productJson:     'script[data-product-json]',
    collectionsJson: 'script[data-product-collections-json]',
    variantInput:    'input[name="id"]',
    optionInputs:    '[data-single-option-selector]',
    productTitle:    '.product__title',   // the <h1> rendered by the product-title snippet
    nativeSkuBlock:  '[data-variant-sku]',
    tabsHolder:      '[data-tabs-holder]',
    tabLink:         '.tab-link',
    tabContent:      '.tab-content',
  };

  // ─── INIT ─────────────────────────────────────────────────────────────────────

  function init() {
    const section = document.querySelector(SEL.section);
    if (!section) return;

    const productJsonEl = section.querySelector(SEL.productJson);
    if (!productJsonEl) return;
    const product = JSON.parse(productJsonEl.textContent);

    // Collection gate — skip if this product isn't in a configured collection
    if (PUBLIC_COLLECTIONS.length > 0) {
      const collectionsEl = section.querySelector(SEL.collectionsJson);
      if (!collectionsEl) return;
      const ids = JSON.parse(collectionsEl.textContent);
      if (!ids.some(function (id) { return PUBLIC_COLLECTIONS.includes(id); })) return;
    }

    const skuConfig   = VARIANT_SKU_CONFIG[product.id];
    const tableConfig = TABLE_MOVE_CONFIG[product.id];

    const locale      = getLocale();
    const isFR        = locale === 'fr';

    // Table move is a one-time DOM operation on load
    if (tableConfig) moveTable(section, tableConfig, isFR);

    if (!skuConfig) return;

    // Store the original product title before we ever modify it
    const titleEl = section.querySelector(SEL.productTitle);
    // Use explicit baseTitle from config to avoid reading an already-formatted DOM title
    // With backward-compat if someone kept the old key (baseTitle)
    const originalTitle = (isFR ? skuConfig.baseTitleFR : skuConfig.baseTitleEN)
      || skuConfig.baseTitle
      || (titleEl ? titleEl.textContent.trim() : product.title);

    const titleTemplate = (isFR ? skuConfig.titleTemplateFR : skuConfig.titleTemplateEN)
      || skuConfig.titleTemplate;

    // Apply for the variant already selected on page load
    const initialVariant = getVariantFromOptions(section, product);
    if (initialVariant) applyUpdates(section, product, initialVariant, skuConfig, originalTitle, titleTemplate, isFR);

    setupVariantChangeListener(section, product, skuConfig, originalTitle, titleTemplate, isFR);
  }

  // ─── VARIANT RESOLUTION ───────────────────────────────────────────────────────

  function getCurrentVariant(section, product) {
    const input = section.querySelector(SEL.variantInput);
    if (!input) return null;
    const id = parseInt(input.value, 10);
    return product.variants.find(function (v) { return v.id === id; }) || null;
  }

  function resolveSkuForVariant(variant, product, config, isFR) {
    const optionName = (isFR && config.skuOptionNameFR) || config.skuOptionName;
    const skuMap     = (isFR && config.skuMapFR)        || config.skuMap;

    if (!optionName || !skuMap) return null;

    const optIndex = product.options
      .map(function (o) { return o.toLowerCase(); })
      .indexOf(optionName.toLowerCase());

    if (optIndex === -1) return null;
    return skuMap[variant.options[optIndex]] || null;
  }

  // ─── APPLY UPDATES ────────────────────────────────────────────────────────────

  function applyUpdates(section, product, variant, config, originalTitle, titleTemplate, isFR) {
    const sku = resolveSkuForVariant(variant, product, config, isFR);
    if (!sku) return;

    // 1. Product <h1> title
    if (titleTemplate) {
      const newTitle = titleTemplate
        .replace('{sku}', sku)
        .replace('{title}', originalTitle);
      const titleEl = section.querySelector(SEL.productTitle);
      if (titleEl) setHeadingText(titleEl, newTitle);
    }

    // 2. Native SKU block — theme may already update this via its own JS, but we
    //    overwrite to stay consistent with the values in skuMap.
    const skuBlock = section.querySelector(SEL.nativeSkuBlock);
    if (skuBlock) {
      const label = skuBlock.textContent.split(':')[0].trim();
      skuBlock.textContent = label + ': ' + sku;
    }

    // 3. SKU entry inside tabs (e.g. <p><strong>SKU:</strong> FLGT01</p>)
    updateSkuInTabs(section, sku);
  }

  // ─── TAB SKU UPDATE ───────────────────────────────────────────────────────────

  function updateSkuInTabs(section, sku) {
    const tabs = section.querySelector(SEL.tabsHolder);
    if (!tabs) return;

    tabs.querySelectorAll(SEL.tabContent).forEach(function (tabContent) {
      tabContent.querySelectorAll('p').forEach(function (p) {
        const strong = p.querySelector('strong');
        if (!strong) return;

        // Match both "<strong>SKU:</strong>" and "<strong>SKU</strong>:"
        const strongText = strong.textContent.trim().replace(/:$/, '').toLowerCase();
        if (strongText !== 'sku') return;

        // The SKU value is in the text node that follows the <strong>.
        // Structure: [<strong>SKU:</strong>][ FLGT01]
        // We update only the trailing text node to preserve the bold label.
        Array.from(p.childNodes).forEach(function (node) {
          if (node.nodeType === Node.TEXT_NODE && node.previousSibling === strong) {
            node.textContent = '\u00A0' + sku; // non-breaking space keeps formatting
          }
        });
      });
    });
  }

  // ─── TABLE MOVE ───────────────────────────────────────────────────────────────

  function moveTable(section, config, isFR) {
    const tabs = section.querySelector(SEL.tabsHolder);
    if (!tabs) return;

    const table = tabs.querySelector(config.tableSelector);
    if (!table) return;

    const targetTitle = (isFR ? config.targetTabTitleFR : config.targetTabTitleEN)
      || config.targetTabTitle; // backward compat

    let targetIndex = null;
    tabs.querySelectorAll(SEL.tabLink).forEach(function (link) {
      const span = link.querySelector('span');
      const text = (span || link).textContent.trim();
      if (text === targetTitle) {
        const m = link.className.match(/tab-link-(\d+)/);
        if (m) targetIndex = m[1];
      }
    });

    if (targetIndex === null) return;

    const targetContent = tabs.querySelector('.tab-content-' + targetIndex);
    if (!targetContent) return;

    const nodeToMove = table.closest('figure') || table;
    targetContent.appendChild(nodeToMove);
  }

  // ─── UTILS ────────────────────────────────────────────────────────────────────

  /**
   * Sets the text of a heading element without destroying any non-text child nodes
   * (e.g. a <span> badge). Replaces all Text nodes with a single updated one.
   */
  function setHeadingText(el, text) {
    const textNodes = Array.from(el.childNodes)
      .filter(function (n) { return n.nodeType === Node.TEXT_NODE; });

    if (textNodes.length > 0) {
      textNodes[0].textContent = text;
      textNodes.slice(1).forEach(function (n) { n.remove(); });
    } else {
      el.textContent = text;
    }
  }

  // ─── LOCALE ───────────────────────────────────────────────────────────────────

  function getLocale() {
    if (window.Shopify && window.Shopify.locale) {
      return window.Shopify.locale.split('-')[0].toLowerCase();
    }
    return (document.documentElement.lang || 'en').split('-')[0].toLowerCase();
  }
  
  // ─── VARIANT CHANGE DETECTION ─────────────────────────────────────────────────

  function setupVariantChangeListener(section, product, config, originalTitle, titleTemplate, isFR) {
    function onVariantChange() {
      const variant = getVariantFromOptions(section, product);
      if (variant) applyUpdates(section, product, variant, config, originalTitle, titleTemplate, isFR);
    }

    // Capture phase (true as 3rd arg) catches events even if the theme's custom
    // elements call stopPropagation() — this is the key difference from before.
    document.addEventListener('change', function (e) {
      if (!section.contains(e.target)) return;
      if (!e.target.matches('[data-single-option-selector]')) return;
      setTimeout(onVariantChange, 30);
    }, true);

    // Belt-and-suspenders: Broadcast may also fire a custom event
    ['theme:variant:change', 'variant:change'].forEach(function (name) {
      section.addEventListener(name, onVariantChange);
    });
  }

  /**
   * Reads which variant is currently selected by inspecting the live option
   * inputs in the DOM — not from input[name="id"], which Broadcast only
   * updates on form submit.
   */
  function getVariantFromOptions(section, product) {
    var selectedOptions = [];

    product.options.forEach(function (_, index) {
      var position = index + 1;
      var dataIndex = 'option' + position;

      // Swatch / radio button
      var checked = section.querySelector(
        'input[type="radio"][data-single-option-selector][data-index="' + dataIndex + '"]:checked'
      );
      if (checked) { selectedOptions.push(checked.value); return; }

      // Popout select (hidden input updated by the popout-select custom element)
      var hidden = section.querySelector(
        'input[type="hidden"][data-single-option-selector][data-index="' + dataIndex + '"]'
      );
      if (hidden) { selectedOptions.push(hidden.value); return; }

      // Native <select> fallback
      var select = section.querySelector(
        'select[data-single-option-selector][data-index="' + dataIndex + '"]'
      );
      if (select) { selectedOptions.push(select.value); }
    });

    if (selectedOptions.length !== product.options.length) return null;

    return product.variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
    }) || null;
  }
  //#endregion

  //#region CART
  // ─── INIT CART ────────────────────────────────────────────────────────────────

  function initCart() {
    // Applies to both the full cart page and the slide-out drawer
    const cartTargets = [
      document.querySelector('[data-section-type="cart"]'),
      document.querySelector('[data-cart-drawer]'),
      document.querySelector('.cart-drawer'),
    ].filter(Boolean);

    if (cartTargets.length === 0) return;

    applyCartTitles();

    // Re-apply after AJAX cart updates (item added/removed/changed).
    // Watch only the items container's direct children to avoid reacting to
    // our own textContent changes further down the tree.
    var debounceTimer = null;
    cartTargets.forEach(function (target) {
      var itemsHolder = target.querySelector('[data-items-holder]') || target;
      new MutationObserver(function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(applyCartTitles, 120);
      }).observe(itemsHolder, { childList: true });
    });
  }

  function applyCartTitles() {
    var locale  = getLocale();
    var isFR    = locale === 'fr';

    // Respect the locale URL prefix (e.g. /fr/cart.js)
    var root    = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var cartUrl = root + 'cart.js';

    fetch(cartUrl)
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cart.items.forEach(function (item) {
          var config = VARIANT_SKU_CONFIG[item.product_id];
          if (!config) return;

          var sku = resolveSkuFromCartItem(item, config, isFR);
          if (!sku) return;

          var titleTemplate = (isFR ? config.titleTemplateFR : config.titleTemplateEN)
            || config.titleTemplate;
          var baseTitle = (isFR ? config.baseTitleFR : config.baseTitleEN)
            || config.baseTitle
            || item.product_title;

          if (!titleTemplate || !baseTitle) return;

          var newTitle = titleTemplate.replace('{sku}', sku).replace('{title}', baseTitle);

          // Update in every cart container visible on the page (page + drawer)
          document.querySelectorAll('[data-item="' + item.key + '"]').forEach(function (itemEl) {
            setCartItemTitle(itemEl, newTitle);
          });
        });
      });
  }

  /**
   * Uses options_with_values from the Cart API — already named, no index lookup needed.
   * e.g. [{name: "Color", value: "Black"}, {name: "Accessory size", value: "XS"}]
   */
  function resolveSkuFromCartItem(item, config, isFR) {
    var optionName = (isFR && config.skuOptionNameFR) || config.skuOptionName;
    var skuMap     = (isFR && config.skuMapFR)        || config.skuMap;
    if (!optionName || !skuMap || !item.options_with_values) return null;

    var option = null;
    item.options_with_values.forEach(function (o) {
      if (o.name.toLowerCase() === optionName.toLowerCase()) option = o;
    });

    return option ? (skuMap[option.value] || null) : null;
  }

  function setCartItemTitle(itemEl, newTitle) {
    var candidates = [
      '.cart__item__title a',   // ← confirmed from cart-line-items.liquid
      '.cart__item__title',
      '.cart-item__name a',
      '.cart-item__name',
    ];

    for (var i = 0; i < candidates.length; i++) {
      var el = itemEl.querySelector(candidates[i]);
      if (el) {
        if (el.textContent.trim() !== newTitle) el.textContent = newTitle;
        return;
      }
    }
  }
  //#endregion

  //#region GENERAL
  // ─── BOOT ─────────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); initCart(); });
  } else {
    init();
    initCart();
  }
  //#endregion

})();